import React, { useState } from "react";
import { Drawer, Button } from "antd";
import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import CoinImage from "../../assets/images/header-coin-icon.svg";
import CloseIcon from "../../assets/images/back-cart.svg";
import { ChevronRight, Trash2 } from "lucide-react";
import { useNavigate } from "react-router";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";

const CartListingDrawer = ({
  open,
  setOpen,
  cartItemsData,
  loadCartItemsData,
}) => {
  const navigate = useNavigate();
  const { deleteCartItem, addCartItem } = useStore();
  // ------------- handlers -------------
  const handleDeleteCartItem = async (itemId, quantity) => {
    const response = await deleteCartItem(itemId, quantity);
    if (response.status === 200) {
      ShowToast(response.message, Severty.SUCCESS);
      loadCartItemsData();
    }
  };
  const handleAddCartQunatity = async (itemId, quantity) => {
    try {
      const response = await addCartItem(itemId, quantity);
      if (response.status === 200) {
        ShowToast(response.message, Severty.SUCCESS);
        loadCartItemsData();
      }
    } catch (err) {}
  };

  return (
    <Drawer
      title={
        <div className="drawer-title-with-close">
          <img
            src={CloseIcon}
            alt="close"
            className="custom-close-icon"
            onClick={() => setOpen(false)}
          />
          <span>Cart ({cartItemsData?.items?.length})</span>
        </div>
      }
      placement="right"
      closable={false}
      open={open}
      onClose={() => setOpen(false)}
      className="cart-drawer"
      width={425}
    >
      <div className="cart-items">
        {cartItemsData?.items?.map((item) => (
          <div className="cart-item" key={item.productId}>
            <img
              src={item.image}
              alt="Product"
              className="cart-product-image"
            />
            <div className="cart-info">
              <div className="item-header">
                <span>{item.name}</span>
                <div className="delete-cart-item">
                  {" "}
                  <Trash2
                    onClick={() =>
                      handleDeleteCartItem(item.productId, item.quantity)
                    }
                  />
                </div>
              </div>
              <div className="quantity-selector-cart">
                <Button
                  icon={<MinusOutlined />}
                  onClick={() => handleDeleteCartItem(item.productId, 1)}
                  shape="circle"
                />
                <span>{item.quantity}</span>
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => handleAddCartQunatity(item.productId, 1)}
                  shape="circle"
                />
              </div>
              <div className="item-price">
                <p>
                  <img src={CoinImage} /> {item.tokens}
                </p>
                <p>{item.price} KD</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {cartItemsData?.items?.length > 0 && (
        <div className="cart-footer">
          <div className="cart-total">
            <div>
              {" "}
              <img src={CoinImage} /> {cartItemsData?.totalTokens}
            </div>
            <div>Shipping fee: {cartItemsData?.shippingFee} KWD</div>
            <div>Grand total: {cartItemsData?.grandTotal} KWD</div>
          </div>
          <Button
            className="checkout-btn"
            onClick={() => navigate("/checkout")}
          >
            Go To Checkout <ChevronRight />
          </Button>
        </div>
      )}
    </Drawer>
  );
};

export default CartListingDrawer;
